exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons__button-container__3uW6n{position:absolute;top:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.buttons__button-container__3uW6n.buttons__inactive__3ngqj{opacity:.3}.buttons__button-container__3uW6n:before{content:\" \";position:absolute;top:0;bottom:0;width:15px}.buttons__button-container__3uW6n.buttons__left__zSv1l{left:0}.buttons__button-container__3uW6n.buttons__left__zSv1l:before{background:linear-gradient(90deg,rgba(0,0,0,.4),hsla(0,0%,100%,0));left:0}.buttons__button-container__3uW6n.buttons__left__zSv1l .buttons__button__2RPO-{transform:scaleX(-1);margin-left:10px}.buttons__button-container__3uW6n.buttons__right__3qYSz{right:0}.buttons__button-container__3uW6n.buttons__right__3qYSz:before{background:linear-gradient(270deg,rgba(0,0,0,.4),hsla(0,0%,100%,0));right:0}.buttons__button-container__3uW6n.buttons__right__3qYSz .buttons__button__2RPO-{margin-right:10px}.buttons__button__2RPO-{color:#fff;font-size:8px}", ""]);

// exports
exports.locals = {
	"button-container": "buttons__button-container__3uW6n",
	"buttonContainer": "buttons__button-container__3uW6n",
	"inactive": "buttons__inactive__3ngqj",
	"left": "buttons__left__zSv1l",
	"button": "buttons__button__2RPO-",
	"right": "buttons__right__3qYSz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/mobile-carousel/buttons.styl
// module id = 2912
// module chunks = 1